import type { ConfigAppName } from '@shared/config/controller/type';
import matrixAssets from '.';
import appOriginMap from './remote/json/appOrigin.json';
import { isProd } from '@shared/env';
import { toLower } from 'lodash-es';

const {
	WATERMARK_BASE64: WATERMARK_BASE64_PROD,
	WATERMARK_BASE64_TEST: WATERMARK_BASE64_TEST,
	REPORT_FORM_URL,
} = matrixAssets.text;

export const WATERMARK_BASE64 = isProd ? WATERMARK_BASE64_PROD : WATERMARK_BASE64_TEST;

export const {
	MATRIX_PRODUCT_PATH,
	MATRIX_FACEBOOK_INSTALL_DECRYPT_SECRET,
	FEEDBACK_QUESTIONNAIRE_URL,
} = matrixAssets.text;

export const { APP_ICON } = matrixAssets.image;

export const { MATRIX_HOME_PAGE_ID, MATRIX_PRODUCT_ID } = {
	MATRIX_HOME_PAGE_ID: Number(matrixAssets.text.MATRIX_HOME_PAGE_ID),
	MATRIX_PRODUCT_ID: Number(matrixAssets.text.MATRIX_PRODUCT_ID),
};

export const REPORT_COMMENT_INFO = {
	url: REPORT_FORM_URL,
	content: 'entry.345523129',
	resourceUrl: 'entry.1672885282',
	userId: 'entry.497733493',
} as const;

export const appOrigin = matrixAssets.text.Matrix_App_Origin || '20000';
export const product = MATRIX_BRAND_NAME || 'a1';
export const businessType = 'A1';
export const packageId = MATRIX_APP_ID || 'art.a1.twa';

export const LowercaseProduct = toLower(product) as ConfigAppName;

export const isA1 = packageId === 'art.a1.twa';

export const MATRIX_APP_ORIGIN_MAP = appOriginMap;
export type MatrixAppOrigin = (typeof MATRIX_APP_ORIGIN_MAP)[keyof typeof MATRIX_APP_ORIGIN_MAP];
